import { useTheme } from "@mui/material";
import { Canvas } from "@react-three/fiber";
import { useScroll } from "framer-motion";
import { useEffect, useState } from "react";
import { degToRad } from "three/src/math/MathUtils";

export const Rings = () => {
  return (
    <div
      style={{
        position: "absolute",
        height: "150vh",
        width: "60%",
        right: "-3rem",
        top: "11rem",
      }}
    >
      <Canvas
        style={{
          width: "100%",
          height: "100%",
        }}
        camera={{
          position: [0, 0, 25],
          fov: 25,
          near: 0.1,
          far: 1000,
        }}
        dpr={window.devicePixelRatio}
        gl={{
          antialias: true,
          alpha: true,
          powerPreference: "high-performance",
        }}
      >
        <ambientLight intensity={0.5} />
        <directionalLight position={[10, 10, 5]} intensity={0.5} />
        <RingsScene />
      </Canvas>
    </div>
  );
};

const RingsScene = () => {
  const theme = useTheme();

  const scrollProgress = useScroll(); // Get scroll progress between 0 and 1
  const spacing = 0.1;
  const [verticalSpacing, setVerticalSpacing] = useState(-0.4);

  useEffect(() => {
    const unsubscribe = scrollProgress.scrollYProgress.on("change", (value) => {
      setVerticalSpacing(0.58 + value * -0.9);
    });

    return () => unsubscribe();
  }, [scrollProgress.scrollYProgress]);

  return (
    <>
      <group rotation={[0, 0, degToRad(0)]}>
        {Array.from({ length: 16 }).map((_, index) => {
          return (
            <mesh
              key={index}
              position={[index * spacing, 2 + index * verticalSpacing, 0]}
              rotation={[degToRad(0), 0, 0]}
              scale={[0.65, 1, 1]}
            >
              <ringGeometry args={[3, 3.025, 200]} />
              <meshStandardMaterial
                emissive={theme.palette.yellow.main}
                color={theme.palette.yellow.main}
                emissiveIntensity={0.2}
                opacity={0.4 - index * 0.0125}
                transparent
              />
            </mesh>
          );
        })}
      </group>
    </>
  );
};
